import React from "react";
import AudioPlayer from "react-h5-audio-player";
import "./AudioPlayer.css";
import "react-h5-audio-player/lib/styles.css";
import { PiWaveformThin } from "react-icons/pi";
import { IoCloseSharp } from "react-icons/io5";
import { formatDate } from "../../../common/Helper/formatDate";

const AudioPlayerFile = ({
  name,
  role,
  audioSrc,
  handleCloseAudioPlayer,
  mode,
  dateCreated,
}) => {
  return (
    <div className="audio-player-content">
      <div className="audio-wave--container">
        <div className="row p-2 align-items-between">
          <div className="col-11 ">
            <h6>
              <span className="mx-1">
                <PiWaveformThin />
              </span>
              Audio Player
            </h6>
          </div>
          <div className="col-1 ">
            <IoCloseSharp
              fontSize={20}
              onClick={() => handleCloseAudioPlayer(mode)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </div>
      <h6 className="p-0 m-1">Date Created: {formatDate(dateCreated)}</h6>
      <p className="text-capitalize font-weight-bold text-secondary p-0 my-2 mx-1">
        <span>{name} </span>
      </p>
      <AudioPlayer
        autoPlay
        src={audioSrc}
        onEnded={() => handleCloseAudioPlayer(mode)}
        style={{ width: "700px", height: "150px" }}
        className="custom-audio-player"
      />
    </div>
  );
};

export default AudioPlayerFile;
